// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calcite-input-label-container {
  display: flex;
}

.calcite-input-text-danger {
  height: 8px;
  padding-left: 3px;
  padding-top: -4px;
  font-family: Inter;
  font-style: normal;
  font-size: 12px;
  /*letter-spacing: -0.0686271px;*/
  color: #FF0000FF;
}

`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
